import { useThemeColors } from '@/hooks/useThemeColors';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProgressCardProps {
    progressPercentage?: number;
}

const ProgressCard: React.FC<ProgressCardProps> = ({ 
    progressPercentage = 0 
}) => {
    const { t } = useTranslation();
    const colors = useThemeColors();

    return (
        <div className="mb-8 rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center justify-between">
                <div>
                    <h2 className="text-lg font-semibold text-gray-900">
                        {t('course.yourProgress')}
                    </h2>
                    <p className="text-sm text-gray-600">
                        {t('course.continueWhereYouLeftOff')}
                    </p>
                </div>
                <div className="text-right">
                    <div className="text-2xl font-bold text-gray-900">
                        {progressPercentage}%
                    </div>
                    <div className="text-xs text-gray-500">
                        {t('course.completed')}
                    </div>
                </div>
            </div>

            <div className="h-2 w-full rounded-full bg-gray-200">
                <div
                    className={`${colors.primaryBg} h-2 rounded-full transition-all duration-500`}
                    style={{ width: `${progressPercentage}%` }}
                ></div>
            </div>
        </div>
    );
};

export default ProgressCard;